import { render } from "./CommentListModal.vue?vue&type=template&id=7dce90f4&scoped=true&ts=true"
import script from "./CommentListModal.vue?vue&type=script&lang=ts"
export * from "./CommentListModal.vue?vue&type=script&lang=ts"

import "./CommentListModal.vue?vue&type=style&index=0&id=7dce90f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dce90f4"]])

export default __exports__